import type { PaperProps } from "@mui/material/Paper";
import type { FC } from "react";
import EDD from "../types/EDD";
import PatientDisposition from "../types/PatientDisposition";
import SuggestionDetailPopoverShell from "./suggestion-detail-popover-shell";
import SuggestionExplainabilityPopoverContent from "./suggestion-explainability-popover-content";

export interface SuggestionExplainabilityPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  suggestion: PatientDisposition | EDD;
  suggestionType: string;
  paperProps?: Partial<PaperProps>;
}

/**
 * Explainability detail: shared {@link SuggestionDetailPopoverShell} +
 * {@link SuggestionExplainabilityPopoverContent}.
 */
const SuggestionExplainabilityPopover: FC<
  SuggestionExplainabilityPopoverProps
> = ({ open, anchorEl, onClose, suggestion, suggestionType, paperProps }) => (
  <SuggestionDetailPopoverShell
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    paperProps={paperProps}
  >
    <SuggestionExplainabilityPopoverContent
      suggestion={suggestion}
      suggestionType={suggestionType}
      onClose={onClose}
    />
  </SuggestionDetailPopoverShell>
);

export default SuggestionExplainabilityPopover;
